"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
var main_1 = require("./main");
var about_1 = require("./about");
var extension_1 = require("./extension");
var Components = angular
    .module("app.components", [
    main_1.default.name,
    extension_1.default.name,
    about_1.default.name
]);
exports.default = Components;



/** WEBPACK FOOTER **
 ** ./src/app/components/index.ts
 **/